import React, { Component } from "react";
import Card from "../../shared/Card";
import { Link } from "react-router-dom";
import EPAIDLetter from "./EPAIDLetter";

const tableBorders = {
  borderTop: "none",
  padding: 0,
};

class EpaProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
    };
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  formatDate(date) {
    let formattedDate = new Date(date).toLocaleDateString();
    return formattedDate;
  }

  render() {
    const profile = (
      <Card
        cardType="default"
        cardHeader="ID Number Profile"
        headerColor="#046B99"
        headerTextColor="white"
        cardBody={
          <div className="epa-profile-card">
            <div className="table-responsive">
              <table className="table" style={{ marginBottom: 0 }}>
                <tbody>
                  <tr>
                    <td style={tableBorders}>ID Number:</td>
                    <td style={tableBorders}>
                    { this.props.EPA_ID.substr(0,3) ==='CAL' && this.props.EPATYPEIND.toLowerCase() === "p" && this.props.EPACATEGORY === 'State'
                      ? (
                        <u><Link to={`#`} onClick={() => EPAIDLetter(this.props.EPA_ID)}>{this.props.EPA_ID}</Link></u>
                        ) 
                    : ( this.props.EPA_ID)
                    }
                    </td>
                  </tr>
                  <tr>
                    <td style={tableBorders}>Facility Name:</td>
                    <td style={tableBorders}>{this.props.FacilityName}</td>
                  </tr>
                  {this.props.EPA_ID.startsWith("CA") && !this.props.IS_TRIBAL ? (
                    <tr>
                      <td style={tableBorders}>ID Number Status:</td>
                      <td
                        style={{
                          color:
                            this.props.Status.toLowerCase() === "active"
                              ? "green"
                              : "red",
                          borderTop: "none",
                          padding: 0,
                        }}
                      >
                        {this.props.Status.toUpperCase()}
                        {this.props.EPATYPEIND.toLowerCase() === "t" ? (
                          this.props.Status.toLowerCase() === "active" ? (
                            <span>
                              {" "}
                              (expires:{" "}
                              {this.formatDate(this.props.INACTIVE_DATE)})
                            </span>
                          ) : (
                            <span>
                              {" "}
                              (expired:{" "}
                              {this.formatDate(this.props.INACTIVE_DATE)})
                            </span>
                          )
                        ) : this.props.Status.toLowerCase() === "inactive" ? (
                          <span>
                            {" "}
                            (expired:{" "}
                            {this.formatDate(this.props.INACTIVE_DATE)})
                          </span>
                        ) : null}
                      </td>
                    </tr>
                  ) : null}
                  <tr>
                    <td style={tableBorders}>ID Type:</td>
                    <td style={tableBorders}>
                      {this.props.IS_TRIBAL ? "TRIBAL" :  
                        this.props.EPATYPEIND.toLowerCase() === "p"
                          ? "PERMANENT"
                          : "TEMPORARY"
                      }
                    </td>
                  </tr>
                  {!this.props.IS_TRIBAL ?
                  <tr>
                    <td style={tableBorders}>ID Category:</td>
                    <td style={tableBorders}>
                      {this.props.EPACATEGORY.toUpperCase()}
                    </td>
                  </tr>
                  : null}
                  <tr>
                    <td style={tableBorders}>Entity Types:</td>
                    <td style={tableBorders}>
                      {this.props.FACILITY_TYPES.toUpperCase()}
                    </td>
                  </tr>
                  {/* {this.props.Status.toLowerCase() == "active" ? null :
                    <tr>
                      <td style={tableBorders}>Inactive Date:</td>
                      <td style={tableBorders}>
                        {this.formatDate(this.props.INACTIVE_DATE)}
                      </td>
                    </tr>
                  } */}
                  {/* <tr>
                    <td style={tableBorders}>NAICS:</td>
                    <td style={tableBorders}>
                      {this.props.NAICS ? this.props.NAICS : ""}
                    </td>
                  </tr> */}
                  {this.props.EPA_ID.startsWith("CA") ? (
                    <tr>
                      <td style={tableBorders}>Issued Date:</td>
                      <td style={tableBorders}>
                        {this.formatDate(this.props.CREATE_DATE)}
                      </td>
                    </tr>
                  ) : null}
                  <tr>
                    <td style={tableBorders}>Last Updated:</td>
                    <td style={tableBorders}>
                      {this.formatDate(this.props.LAST_UPDATED)}
                    </td>
                  </tr>
                  {this.props.TRANS_ID > 0 ? (
                    <tr>
                      <td style={tableBorders}>Transporter Registration Number:</td>
                      <td style={tableBorders}>
                        <u><Link to={`/reports/transporter/${this.props.TRANS_ID}`} target="_blank">{this.props.TRANS_ID}</Link></u>
                      </td>
                    </tr>
                  ) : null}
                  {this.props.TRANS_ID > 0 ? (
                    <tr>
                      <td style={tableBorders}>Transporter Status:</td>
                      <td style={tableBorders}>
                        {this.props.TRANS_STATUS}
                      </td>
                    </tr>
                  ) : null}                
                </tbody>
              </table>
            </div>
          </div>

          //   <div className="half epa-profile-labels">
          //     <div>EPA ID:</div>
          //     <div>Facility Name:</div>
          //     <div>NAICS:</div>
          //     <div>Status:</div>
          //     <div>Handler Type:</div>
          //     <div>Inactive Date:</div>
          //     <div>Record Entered:</div>
          //     <div>Last Updated:</div>
          //   </div>
          //   <div className="half epa-profile-data">
          //     <div>{this.props.EPA_ID}</div>
          //     <div>{this.props.FacilityName}</div>
          //     <div>{this.props.NAICS ? this.props.NAICS.SIC : ""}</div>
          //     <div>{this.toTitleCase(this.props.Status)}</div>
          //     <div>{this.props.FACILITY_TYPES}</div>
          //     <div>{this.formatDate(this.props.INACTIVE_DATE)}</div>
          //     <div>{this.formatDate(this.props.CREATE_DATE)}</div>
          //     <div>{this.formatDate(this.props.LAST_UPDATED)}</div>
          //   </div>
          // </div>
        }
        cardColor="white"
      />
    );

    return <div>{profile}</div>;
  }
}

export default EpaProfile;
